import type { SxProps, Theme } from '@mui/material';

/**
 * Shared sx for a multiline "notes" textarea -- fixed height + rounded corners instead of
 * the bare underlined default. Previously duplicated inline in CaseCloseModal.tsx and
 * TransactionRedemptionTab.tsx; centralized here so every notes-style field looks the same
 * and a future tweak is a one-file change.
 */
export const NOTES_TEXTAREA_SX: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    height: '120px',
  },
};
